export const reportsDateFilterKey = 'reports_date_filter';
export const reportsRefreshStateKey = 'reports_refresh_state';
export const reportsFullGraphKey = 'full_graph';
export const apiFilterKey = 'api_filters';
